/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  BackfillDashboardStoragePathParameters,
  BackfillUniqueErrorsPathParameters,
  DownloadExportPathParameters,
  GetTenantStorageStatusParams,
  TLBackfillViewRolesResponse,
  TLDHExportLogResponse,
  TLDHExportRequest,
  TLDHImportLogResponse,
  TLDHImportRequest,
  TLDownloadUrlResponse,
  TLHTTPValidationError,
  TLStorageBackfillResponse,
  TLStorageModeRequest,
  TLStorageModeResponse,
  TLSuccessResponse,
  TLTenantStorageStatusResponse,
  TriggerCalculationPathParameters,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Backfill Dh View Roles
 */
export const backfillDhViewRoles = (options?: SecondParameter<typeof apiInstance>, signal?: AbortSignal) => {
  return apiInstance<TLBackfillViewRolesResponse>(
    { url: `/v2/data-harmonization/admin/backfill-view-roles`, method: 'POST', signal },
    options,
  );
};

export const getBackfillDhViewRolesQueryKey = () => {
  return ['POST', 'v2', 'data-harmonization', 'admin', 'backfill-view-roles'] as const;
};

export const getBackfillDhViewRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof backfillDhViewRoles>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDhViewRoles>>, TError, TData>>;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBackfillDhViewRolesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backfillDhViewRoles>>> = ({ signal }) =>
    backfillDhViewRoles(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof backfillDhViewRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BackfillDhViewRolesQueryResult = NonNullable<Awaited<ReturnType<typeof backfillDhViewRoles>>>;
export type BackfillDhViewRolesQueryError = ErrorType<unknown>;

export function useBackfillDhViewRoles<
  TData = Awaited<ReturnType<typeof backfillDhViewRoles>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDhViewRoles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backfillDhViewRoles>>,
          TError,
          Awaited<ReturnType<typeof backfillDhViewRoles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBackfillDhViewRoles<
  TData = Awaited<ReturnType<typeof backfillDhViewRoles>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDhViewRoles>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backfillDhViewRoles>>,
          TError,
          Awaited<ReturnType<typeof backfillDhViewRoles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBackfillDhViewRoles<
  TData = Awaited<ReturnType<typeof backfillDhViewRoles>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDhViewRoles>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Backfill Dh View Roles
 */

export function useBackfillDhViewRoles<
  TData = Awaited<ReturnType<typeof backfillDhViewRoles>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDhViewRoles>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBackfillDhViewRolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Backfill Dh View Roles
 */
export const prefetchBackfillDhViewRolesQuery = async <
  TData = Awaited<ReturnType<typeof backfillDhViewRoles>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDhViewRoles>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getBackfillDhViewRolesQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Backfill Dh View Roles
 */
export const invalidateBackfillDhViewRoles = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getBackfillDhViewRolesQueryKey() }, options);

  return queryClient;
};

/**
 * @summary Invalidate Cache
 */
export const invalidateCache = (options?: SecondParameter<typeof apiInstance>, signal?: AbortSignal) => {
  return apiInstance<TLSuccessResponse>(
    { url: `/v2/data-harmonization/admin/cache/invalidate`, method: 'POST', signal },
    options,
  );
};

export const getInvalidateCacheQueryKey = () => {
  return ['POST', 'v2', 'data-harmonization', 'admin', 'cache', 'invalidate'] as const;
};

export const getInvalidateCacheQueryOptions = <
  TData = Awaited<ReturnType<typeof invalidateCache>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateCache>>, TError, TData>>;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getInvalidateCacheQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof invalidateCache>>> = ({ signal }) =>
    invalidateCache(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof invalidateCache>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type InvalidateCacheQueryResult = NonNullable<Awaited<ReturnType<typeof invalidateCache>>>;
export type InvalidateCacheQueryError = ErrorType<unknown>;

export function useInvalidateCache<TData = Awaited<ReturnType<typeof invalidateCache>>, TError = ErrorType<unknown>>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateCache>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invalidateCache>>,
          TError,
          Awaited<ReturnType<typeof invalidateCache>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInvalidateCache<TData = Awaited<ReturnType<typeof invalidateCache>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateCache>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invalidateCache>>,
          TError,
          Awaited<ReturnType<typeof invalidateCache>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInvalidateCache<TData = Awaited<ReturnType<typeof invalidateCache>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateCache>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Invalidate Cache
 */

export function useInvalidateCache<TData = Awaited<ReturnType<typeof invalidateCache>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateCache>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getInvalidateCacheQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Invalidate Cache
 */
export const prefetchInvalidateCacheQuery = async <
  TData = Awaited<ReturnType<typeof invalidateCache>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof invalidateCache>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getInvalidateCacheQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Invalidate Cache
 */
export const invalidateInvalidateCache = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getInvalidateCacheQueryKey() }, options);

  return queryClient;
};

/**
 * Migrate a dashboard's existing program-backed results into the Foundry lake.
 *
 * Runs as a background task (verify-then-point per execution); progress shows up in the
 * storage-status rollup as the program count falls and the lake count rises.
 * @summary Backfill Dashboard Storage
 */
export const backfillDashboardStorage = (
  { dashboardId }: BackfillDashboardStoragePathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLStorageBackfillResponse>(
    { url: `/v2/data-harmonization/admin/dashboards/${dashboardId}/backfill-storage`, method: 'POST', signal },
    options,
  );
};

export const getBackfillDashboardStorageQueryKey = ({ dashboardId }: BackfillDashboardStoragePathParameters) => {
  return ['POST', 'v2', 'data-harmonization', 'admin', 'dashboards', dashboardId, 'backfill-storage'] as const;
};

export const getBackfillDashboardStorageQueryOptions = <
  TData = Awaited<ReturnType<typeof backfillDashboardStorage>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardId }: BackfillDashboardStoragePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDashboardStorage>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBackfillDashboardStorageQueryKey({ dashboardId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backfillDashboardStorage>>> = ({ signal }) =>
    backfillDashboardStorage({ dashboardId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: dashboardId !== null && dashboardId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof backfillDashboardStorage>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type BackfillDashboardStorageQueryResult = NonNullable<Awaited<ReturnType<typeof backfillDashboardStorage>>>;
export type BackfillDashboardStorageQueryError = ErrorType<TLHTTPValidationError>;

export function useBackfillDashboardStorage<
  TData = Awaited<ReturnType<typeof backfillDashboardStorage>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: BackfillDashboardStoragePathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDashboardStorage>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backfillDashboardStorage>>,
          TError,
          Awaited<ReturnType<typeof backfillDashboardStorage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBackfillDashboardStorage<
  TData = Awaited<ReturnType<typeof backfillDashboardStorage>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: BackfillDashboardStoragePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDashboardStorage>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backfillDashboardStorage>>,
          TError,
          Awaited<ReturnType<typeof backfillDashboardStorage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBackfillDashboardStorage<
  TData = Awaited<ReturnType<typeof backfillDashboardStorage>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: BackfillDashboardStoragePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDashboardStorage>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Backfill Dashboard Storage
 */

export function useBackfillDashboardStorage<
  TData = Awaited<ReturnType<typeof backfillDashboardStorage>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardId }: BackfillDashboardStoragePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDashboardStorage>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBackfillDashboardStorageQueryOptions({ dashboardId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Backfill Dashboard Storage
 */
export const prefetchBackfillDashboardStorageQuery = async <
  TData = Awaited<ReturnType<typeof backfillDashboardStorage>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { dashboardId }: BackfillDashboardStoragePathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillDashboardStorage>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getBackfillDashboardStorageQueryOptions({ dashboardId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Backfill Dashboard Storage
 */
export const invalidateBackfillDashboardStorage = async (
  queryClient: QueryClient,
  { dashboardId }: BackfillDashboardStoragePathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getBackfillDashboardStorageQueryKey({ dashboardId }) }, options);

  return queryClient;
};

/**
 * @summary Backfill Unique Errors
 */
export const backfillUniqueErrors = (
  { dashboardId }: BackfillUniqueErrorsPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSuccessResponse>(
    { url: `/v2/data-harmonization/admin/dashboards/${dashboardId}/backfill-unique-errors`, method: 'POST', signal },
    options,
  );
};

export const getBackfillUniqueErrorsQueryKey = ({ dashboardId }: BackfillUniqueErrorsPathParameters) => {
  return ['POST', 'v2', 'data-harmonization', 'admin', 'dashboards', dashboardId, 'backfill-unique-errors'] as const;
};

export const getBackfillUniqueErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof backfillUniqueErrors>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardId }: BackfillUniqueErrorsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillUniqueErrors>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBackfillUniqueErrorsQueryKey({ dashboardId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backfillUniqueErrors>>> = ({ signal }) =>
    backfillUniqueErrors({ dashboardId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: dashboardId !== null && dashboardId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof backfillUniqueErrors>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type BackfillUniqueErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof backfillUniqueErrors>>>;
export type BackfillUniqueErrorsQueryError = ErrorType<TLHTTPValidationError>;

export function useBackfillUniqueErrors<
  TData = Awaited<ReturnType<typeof backfillUniqueErrors>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: BackfillUniqueErrorsPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillUniqueErrors>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backfillUniqueErrors>>,
          TError,
          Awaited<ReturnType<typeof backfillUniqueErrors>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBackfillUniqueErrors<
  TData = Awaited<ReturnType<typeof backfillUniqueErrors>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: BackfillUniqueErrorsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillUniqueErrors>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backfillUniqueErrors>>,
          TError,
          Awaited<ReturnType<typeof backfillUniqueErrors>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBackfillUniqueErrors<
  TData = Awaited<ReturnType<typeof backfillUniqueErrors>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: BackfillUniqueErrorsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillUniqueErrors>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Backfill Unique Errors
 */

export function useBackfillUniqueErrors<
  TData = Awaited<ReturnType<typeof backfillUniqueErrors>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardId }: BackfillUniqueErrorsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillUniqueErrors>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBackfillUniqueErrorsQueryOptions({ dashboardId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Backfill Unique Errors
 */
export const prefetchBackfillUniqueErrorsQuery = async <
  TData = Awaited<ReturnType<typeof backfillUniqueErrors>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { dashboardId }: BackfillUniqueErrorsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof backfillUniqueErrors>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getBackfillUniqueErrorsQueryOptions({ dashboardId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Backfill Unique Errors
 */
export const invalidateBackfillUniqueErrors = async (
  queryClient: QueryClient,
  { dashboardId }: BackfillUniqueErrorsPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getBackfillUniqueErrorsQueryKey({ dashboardId }) }, options);

  return queryClient;
};

/**
 * @summary Trigger Calculation
 */
export const triggerCalculation = (
  { dashboardId, calculationType }: TriggerCalculationPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSuccessResponse>(
    {
      url: `/v2/data-harmonization/admin/dashboards/${dashboardId}/calculations/${calculationType}/trigger`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getTriggerCalculationQueryKey = ({ dashboardId, calculationType }: TriggerCalculationPathParameters) => {
  return [
    'POST',
    'v2',
    'data-harmonization',
    'admin',
    'dashboards',
    dashboardId,
    'calculations',
    calculationType,
    'trigger',
  ] as const;
};

export const getTriggerCalculationQueryOptions = <
  TData = Awaited<ReturnType<typeof triggerCalculation>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardId, calculationType }: TriggerCalculationPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerCalculation>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTriggerCalculationQueryKey({ dashboardId, calculationType });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof triggerCalculation>>> = ({ signal }) =>
    triggerCalculation({ dashboardId, calculationType }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      dashboardId !== null && dashboardId !== undefined && calculationType !== null && calculationType !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof triggerCalculation>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type TriggerCalculationQueryResult = NonNullable<Awaited<ReturnType<typeof triggerCalculation>>>;
export type TriggerCalculationQueryError = ErrorType<TLHTTPValidationError>;

export function useTriggerCalculation<
  TData = Awaited<ReturnType<typeof triggerCalculation>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: TriggerCalculationPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerCalculation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggerCalculation>>,
          TError,
          Awaited<ReturnType<typeof triggerCalculation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggerCalculation<
  TData = Awaited<ReturnType<typeof triggerCalculation>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: TriggerCalculationPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerCalculation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof triggerCalculation>>,
          TError,
          Awaited<ReturnType<typeof triggerCalculation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTriggerCalculation<
  TData = Awaited<ReturnType<typeof triggerCalculation>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: TriggerCalculationPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerCalculation>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Trigger Calculation
 */

export function useTriggerCalculation<
  TData = Awaited<ReturnType<typeof triggerCalculation>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardId, calculationType }: TriggerCalculationPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerCalculation>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTriggerCalculationQueryOptions({ dashboardId, calculationType }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Trigger Calculation
 */
export const prefetchTriggerCalculationQuery = async <
  TData = Awaited<ReturnType<typeof triggerCalculation>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { dashboardId, calculationType }: TriggerCalculationPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof triggerCalculation>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getTriggerCalculationQueryOptions({ dashboardId, calculationType }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Trigger Calculation
 */
export const invalidateTriggerCalculation = async (
  queryClient: QueryClient,
  { dashboardId, calculationType }: TriggerCalculationPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getTriggerCalculationQueryKey({ dashboardId, calculationType }) },
    options,
  );

  return queryClient;
};

/**
 * @summary Export Dashboards
 */
export const exportDashboards = (
  tLDHExportRequest: BodyType<TLDHExportRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLDHExportLogResponse>(
    {
      url: `/v2/data-harmonization/admin/export`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLDHExportRequest,
      signal,
    },
    options,
  );
};

export const getExportDashboardsQueryKey = (tLDHExportRequest?: BodyType<TLDHExportRequest>) => {
  return ['POST', 'v2', 'data-harmonization', 'admin', 'export', tLDHExportRequest] as const;
};

export const getExportDashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHExportRequest: BodyType<TLDHExportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDashboards>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportDashboardsQueryKey(tLDHExportRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportDashboards>>> = ({ signal }) =>
    exportDashboards(tLDHExportRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportDashboards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportDashboardsQueryResult = NonNullable<Awaited<ReturnType<typeof exportDashboards>>>;
export type ExportDashboardsQueryError = ErrorType<TLHTTPValidationError>;

export function useExportDashboards<
  TData = Awaited<ReturnType<typeof exportDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHExportRequest: BodyType<TLDHExportRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDashboards>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportDashboards>>,
          TError,
          Awaited<ReturnType<typeof exportDashboards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportDashboards<
  TData = Awaited<ReturnType<typeof exportDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHExportRequest: BodyType<TLDHExportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDashboards>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportDashboards>>,
          TError,
          Awaited<ReturnType<typeof exportDashboards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useExportDashboards<
  TData = Awaited<ReturnType<typeof exportDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHExportRequest: BodyType<TLDHExportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDashboards>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export Dashboards
 */

export function useExportDashboards<
  TData = Awaited<ReturnType<typeof exportDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHExportRequest: BodyType<TLDHExportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDashboards>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportDashboardsQueryOptions(tLDHExportRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Export Dashboards
 */
export const prefetchExportDashboardsQuery = async <
  TData = Awaited<ReturnType<typeof exportDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLDHExportRequest: BodyType<TLDHExportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof exportDashboards>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getExportDashboardsQueryOptions(tLDHExportRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Export Dashboards
 */
export const invalidateExportDashboards = async (
  queryClient: QueryClient,
  tLDHExportRequest: BodyType<TLDHExportRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getExportDashboardsQueryKey(tLDHExportRequest) }, options);

  return queryClient;
};

/**
 * @summary Download Export
 */
export const downloadExport = (
  { exportId }: DownloadExportPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLDownloadUrlResponse>(
    { url: `/v2/data-harmonization/admin/export/${exportId}/download`, method: 'GET', signal },
    options,
  );
};

export const getDownloadExportQueryKey = ({ exportId }: DownloadExportPathParameters) => {
  return ['v2', 'data-harmonization', 'admin', 'export', exportId, 'download'] as const;
};

export const getDownloadExportQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadExport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { exportId }: DownloadExportPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadExportQueryKey({ exportId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadExport>>> = ({ signal }) =>
    downloadExport({ exportId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: exportId !== null && exportId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DownloadExportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadExport>>>;
export type DownloadExportQueryError = ErrorType<TLHTTPValidationError>;

export function useDownloadExport<
  TData = Awaited<ReturnType<typeof downloadExport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DownloadExportPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExport>>,
          TError,
          Awaited<ReturnType<typeof downloadExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadExport<
  TData = Awaited<ReturnType<typeof downloadExport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DownloadExportPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExport>>,
          TError,
          Awaited<ReturnType<typeof downloadExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadExport<
  TData = Awaited<ReturnType<typeof downloadExport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DownloadExportPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download Export
 */

export function useDownloadExport<
  TData = Awaited<ReturnType<typeof downloadExport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { exportId }: DownloadExportPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadExportQueryOptions({ exportId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download Export
 */
export const prefetchDownloadExportQuery = async <
  TData = Awaited<ReturnType<typeof downloadExport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { exportId }: DownloadExportPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExport>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDownloadExportQueryOptions({ exportId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Download Export
 */
export const invalidateDownloadExport = async (
  queryClient: QueryClient,
  { exportId }: DownloadExportPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getDownloadExportQueryKey({ exportId }) }, options);

  return queryClient;
};

/**
 * @summary Get All Exports
 */
export const getAllExports = (options?: SecondParameter<typeof apiInstance>, signal?: AbortSignal) => {
  return apiInstance<TLDHExportLogResponse[]>(
    { url: `/v2/data-harmonization/admin/exports`, method: 'GET', signal },
    options,
  );
};

export const getGetAllExportsQueryKey = () => {
  return ['v2', 'data-harmonization', 'admin', 'exports'] as const;
};

export const getGetAllExportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllExports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllExports>>, TError, TData>>;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllExportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllExports>>> = ({ signal }) =>
    getAllExports(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllExports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllExportsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllExports>>>;
export type GetAllExportsQueryError = ErrorType<unknown>;

export function useGetAllExports<TData = Awaited<ReturnType<typeof getAllExports>>, TError = ErrorType<unknown>>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllExports>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllExports>>,
          TError,
          Awaited<ReturnType<typeof getAllExports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllExports<TData = Awaited<ReturnType<typeof getAllExports>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllExports>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllExports>>,
          TError,
          Awaited<ReturnType<typeof getAllExports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllExports<TData = Awaited<ReturnType<typeof getAllExports>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllExports>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get All Exports
 */

export function useGetAllExports<TData = Awaited<ReturnType<typeof getAllExports>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllExports>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllExportsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get All Exports
 */
export const prefetchGetAllExportsQuery = async <
  TData = Awaited<ReturnType<typeof getAllExports>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllExports>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetAllExportsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get All Exports
 */
export const invalidateGetAllExports = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetAllExportsQueryKey() }, options);

  return queryClient;
};

/**
 * @summary Import Dashboards
 */
export const importDashboards = (
  tLDHImportRequest: BodyType<TLDHImportRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLDHImportLogResponse>(
    {
      url: `/v2/data-harmonization/admin/import`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLDHImportRequest,
      signal,
    },
    options,
  );
};

export const getImportDashboardsQueryKey = (tLDHImportRequest?: BodyType<TLDHImportRequest>) => {
  return ['POST', 'v2', 'data-harmonization', 'admin', 'import', tLDHImportRequest] as const;
};

export const getImportDashboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof importDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHImportRequest: BodyType<TLDHImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importDashboards>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getImportDashboardsQueryKey(tLDHImportRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof importDashboards>>> = ({ signal }) =>
    importDashboards(tLDHImportRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof importDashboards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ImportDashboardsQueryResult = NonNullable<Awaited<ReturnType<typeof importDashboards>>>;
export type ImportDashboardsQueryError = ErrorType<TLHTTPValidationError>;

export function useImportDashboards<
  TData = Awaited<ReturnType<typeof importDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHImportRequest: BodyType<TLDHImportRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof importDashboards>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importDashboards>>,
          TError,
          Awaited<ReturnType<typeof importDashboards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useImportDashboards<
  TData = Awaited<ReturnType<typeof importDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHImportRequest: BodyType<TLDHImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importDashboards>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importDashboards>>,
          TError,
          Awaited<ReturnType<typeof importDashboards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useImportDashboards<
  TData = Awaited<ReturnType<typeof importDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHImportRequest: BodyType<TLDHImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importDashboards>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import Dashboards
 */

export function useImportDashboards<
  TData = Awaited<ReturnType<typeof importDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLDHImportRequest: BodyType<TLDHImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importDashboards>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getImportDashboardsQueryOptions(tLDHImportRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Import Dashboards
 */
export const prefetchImportDashboardsQuery = async <
  TData = Awaited<ReturnType<typeof importDashboards>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLDHImportRequest: BodyType<TLDHImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof importDashboards>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getImportDashboardsQueryOptions(tLDHImportRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Import Dashboards
 */
export const invalidateImportDashboards = async (
  queryClient: QueryClient,
  tLDHImportRequest: BodyType<TLDHImportRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getImportDashboardsQueryKey(tLDHImportRequest) }, options);

  return queryClient;
};

/**
 * @summary Get All Imports
 */
export const getAllImports = (options?: SecondParameter<typeof apiInstance>, signal?: AbortSignal) => {
  return apiInstance<TLDHImportLogResponse[]>(
    { url: `/v2/data-harmonization/admin/imports`, method: 'GET', signal },
    options,
  );
};

export const getGetAllImportsQueryKey = () => {
  return ['v2', 'data-harmonization', 'admin', 'imports'] as const;
};

export const getGetAllImportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllImports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllImports>>, TError, TData>>;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllImportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllImports>>> = ({ signal }) =>
    getAllImports(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllImportsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllImports>>>;
export type GetAllImportsQueryError = ErrorType<unknown>;

export function useGetAllImports<TData = Awaited<ReturnType<typeof getAllImports>>, TError = ErrorType<unknown>>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllImports>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllImports>>,
          TError,
          Awaited<ReturnType<typeof getAllImports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllImports<TData = Awaited<ReturnType<typeof getAllImports>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllImports>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllImports>>,
          TError,
          Awaited<ReturnType<typeof getAllImports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllImports<TData = Awaited<ReturnType<typeof getAllImports>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllImports>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get All Imports
 */

export function useGetAllImports<TData = Awaited<ReturnType<typeof getAllImports>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllImports>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllImportsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get All Imports
 */
export const prefetchGetAllImportsQuery = async <
  TData = Awaited<ReturnType<typeof getAllImports>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllImports>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetAllImportsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get All Imports
 */
export const invalidateGetAllImports = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetAllImportsQueryKey() }, options);

  return queryClient;
};

/**
 * @summary Set Storage Mode
 */
export const setStorageMode = (
  tLStorageModeRequest: BodyType<TLStorageModeRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLStorageModeResponse>(
    {
      url: `/v2/data-harmonization/admin/storage-mode`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLStorageModeRequest,
      signal,
    },
    options,
  );
};

export const getSetStorageModeQueryKey = (tLStorageModeRequest?: BodyType<TLStorageModeRequest>) => {
  return ['POST', 'v2', 'data-harmonization', 'admin', 'storage-mode', tLStorageModeRequest] as const;
};

export const getSetStorageModeQueryOptions = <
  TData = Awaited<ReturnType<typeof setStorageMode>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStorageModeRequest: BodyType<TLStorageModeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof setStorageMode>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSetStorageModeQueryKey(tLStorageModeRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof setStorageMode>>> = ({ signal }) =>
    setStorageMode(tLStorageModeRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof setStorageMode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SetStorageModeQueryResult = NonNullable<Awaited<ReturnType<typeof setStorageMode>>>;
export type SetStorageModeQueryError = ErrorType<TLHTTPValidationError>;

export function useSetStorageMode<
  TData = Awaited<ReturnType<typeof setStorageMode>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStorageModeRequest: BodyType<TLStorageModeRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof setStorageMode>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof setStorageMode>>,
          TError,
          Awaited<ReturnType<typeof setStorageMode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSetStorageMode<
  TData = Awaited<ReturnType<typeof setStorageMode>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStorageModeRequest: BodyType<TLStorageModeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof setStorageMode>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof setStorageMode>>,
          TError,
          Awaited<ReturnType<typeof setStorageMode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSetStorageMode<
  TData = Awaited<ReturnType<typeof setStorageMode>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStorageModeRequest: BodyType<TLStorageModeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof setStorageMode>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Set Storage Mode
 */

export function useSetStorageMode<
  TData = Awaited<ReturnType<typeof setStorageMode>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStorageModeRequest: BodyType<TLStorageModeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof setStorageMode>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSetStorageModeQueryOptions(tLStorageModeRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Set Storage Mode
 */
export const prefetchSetStorageModeQuery = async <
  TData = Awaited<ReturnType<typeof setStorageMode>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLStorageModeRequest: BodyType<TLStorageModeRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof setStorageMode>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSetStorageModeQueryOptions(tLStorageModeRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Set Storage Mode
 */
export const invalidateSetStorageMode = async (
  queryClient: QueryClient,
  tLStorageModeRequest: BodyType<TLStorageModeRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getSetStorageModeQueryKey(tLStorageModeRequest) }, options);

  return queryClient;
};

/**
 * Lake-vs-program storage rollup for every active dashboard (migration visibility).
 * @summary Get Tenant Storage Status
 */
export const getTenantStorageStatus = (
  params?: GetTenantStorageStatusParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLTenantStorageStatusResponse>(
    { url: `/v2/data-harmonization/admin/storage-status`, method: 'GET', params, signal },
    options,
  );
};

export const getGetTenantStorageStatusQueryKey = (params?: GetTenantStorageStatusParams) => {
  return ['v2', 'data-harmonization', 'admin', 'storage-status', ...(params ? [params] : [])] as const;
};

export const getGetTenantStorageStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenantStorageStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: GetTenantStorageStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantStorageStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTenantStorageStatusQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantStorageStatus>>> = ({ signal }) =>
    getTenantStorageStatus(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenantStorageStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTenantStorageStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantStorageStatus>>>;
export type GetTenantStorageStatusQueryError = ErrorType<TLHTTPValidationError>;

export function useGetTenantStorageStatus<
  TData = Awaited<ReturnType<typeof getTenantStorageStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params: undefined | GetTenantStorageStatusParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantStorageStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantStorageStatus>>,
          TError,
          Awaited<ReturnType<typeof getTenantStorageStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTenantStorageStatus<
  TData = Awaited<ReturnType<typeof getTenantStorageStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: GetTenantStorageStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantStorageStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantStorageStatus>>,
          TError,
          Awaited<ReturnType<typeof getTenantStorageStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTenantStorageStatus<
  TData = Awaited<ReturnType<typeof getTenantStorageStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: GetTenantStorageStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantStorageStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Tenant Storage Status
 */

export function useGetTenantStorageStatus<
  TData = Awaited<ReturnType<typeof getTenantStorageStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: GetTenantStorageStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantStorageStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTenantStorageStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Tenant Storage Status
 */
export const prefetchGetTenantStorageStatusQuery = async <
  TData = Awaited<ReturnType<typeof getTenantStorageStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  params?: GetTenantStorageStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantStorageStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetTenantStorageStatusQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Tenant Storage Status
 */
export const invalidateGetTenantStorageStatus = async (
  queryClient: QueryClient,
  params?: GetTenantStorageStatusParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetTenantStorageStatusQueryKey(params) }, options);

  return queryClient;
};
